module.exports = __webpack_public_path__ + "img/GAME_YUTNORI1.e858ff02.jpg";